import { ClienteService } from '../services/cliente.service';
import { ListadoClientes } from '../models/viewmodels/listadoClientes';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
var ClientesComponent = /** @class */ (function () {
    function ClientesComponent(clienteService, router) {
        this.clienteService = clienteService;
        this.router = router;
        this.query = new FormControl();
        this.pagina = 0;
        this.cantidadPorPagina = 20;
        this.listado = null;
        this.paginas = 0;
        this.isLoading = true;
        this.display = false;
        this.alert = {
            tipo: "success",
            titulo: "",
            mensaje: "",
            visible: false
        };
        this.listado = new ListadoClientes();
        this.listado.clientes = new Array();
    }
    ClientesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.obtenerClientes();
        this.query.valueChanges
            .debounceTime(400)
            .distinctUntilChanged()
            .subscribe(function (term) {
            if (term.length == 0) {
                _this.pagina = 0;
                _this.obtenerClientes();
            }
            else if (term.length > 2) {
                _this.obtenerClientes();
            }
        });
    };
    ClientesComponent.prototype.obtenerClientes = function (paginaActual) {
        var _this = this;
        this.pagina = paginaActual == null ? 0 : paginaActual;
        this.spinner.isRunning = true;
        this.clienteService.listado(this.pagina, this.cantidadPorPagina, this.query.value ? this.query.value : "").subscribe(function (result) {
            _this.spinner.isRunning = false;
            _this.listado = result;
            if (_this.listado && _this.listado.total > 0) {
                _this.paginas = Math.floor((_this.listado.total + _this.cantidadPorPagina - 1) / _this.cantidadPorPagina);
            }
        });
    };
    ClientesComponent.prototype.anterior = function () {
        this.obtenerClientes(this.pagina - 1);
    };
    ClientesComponent.prototype.siguiente = function () {
        this.obtenerClientes(this.pagina + 1);
    };
    ClientesComponent.prototype.buscar = function () {
        this.obtenerClientes();
    };
    ClientesComponent.prototype.historica = function (cliente) {
        this.clienteService.setCliente(cliente);
        this.router.navigate(['dashboard/clientes/ctacte/historica']);
    };
    ClientesComponent.prototype.aplicada = function (cliente) {
        this.clienteService.setCliente(cliente);
        this.router.navigate(['dashboard/clientes/ctacte/aplicada']);
    };
    ClientesComponent.prototype.editar = function (cliente) {
        this.clienteService.setCliente(cliente);
        this.router.navigate(['dashboard/clientes/editar']);
    };
    ClientesComponent.prototype.reenviar = function (id) {
        var _this = this;
        this.spinner.isRunning = true;
        this.clienteService.reenviarRegistracion(id).subscribe(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Reenviar mail registración";
            if (result.status == 201) {
                _this.alert.tipo = "success";
                _this.alert.mensaje = "El email se ha reenviado correctamente";
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "El email no se han podido reenviar. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
            _this.spinner.isRunning = false;
        }, function (error) {
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = "Reenviar mail registración";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "El email no se han podido reenviar. Por favor vuelva a intentarlo.";
        });
    };
    ClientesComponent.prototype.paginate = function (event) {
        //event.first = Index of the first record
        //event.rows = Number of rows to display in new page
        //event.page = Index of the new page
        //event.pageCount = Total number of pages
        this.obtenerClientes(event.page);
    };
    ClientesComponent.prototype.showDialog = function (cliente) {
        this.cliente = cliente;
        this.display = true;
    };
    ClientesComponent.prototype.eliminar = function () {
        var _this = this;
        this.display = false;
        this.spinner.isRunning = true;
        this.clienteService.eliminar(this.cliente.id).subscribe(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Eliminar cliente";
            if (result.status == 204) {
                _this.alert.tipo = "success";
                _this.alert.mensaje = "El cliente " + _this.cliente.razonSocial + " se ha eliminado correctamente";
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "El cliente no se ha podido eliminar. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
            _this.listado.clientes = _this.listado.clientes.filter(function (u) {
                return u.id != _this.cliente.id;
            });
            _this.cliente = null;
            _this.spinner.isRunning = false;
        }, function (error) {
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = "Eliminar cliente";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "El cliente no se ha podido eliminar. Por favor vuelva a intentarlo.";
        });
    };
    ClientesComponent.ctorParameters = function () { return [{ type: ClienteService }, { type: Router }]; };
    return ClientesComponent;
}());
export { ClientesComponent };
//# sourceMappingURL=clientes.component.js.map


// WEBPACK FOOTER //
// clientes.component.js